/*
  "Head to toe" option row (snippets/fit-option.liquid).

  A visual layer over the Frequently Bought Together widget (Code Black Belt):
  - what is in the bundle, every price, the total and the discount are READ from the app's widget;
  - choosing here clicks the app's real checkboxes and changes its real size selectors;
  - the product's buy button, while the fit is selected, clicks the app's real button.
  Nothing is calculated or added to the cart by this file. If the widget is not on the page,
  the row stays hidden and the product page works as usual.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-fit-option]');
  var cfgEl = document.querySelector('[data-fit-config]');
  if (!root || !cfgEl || root.dataset.fitInit) return;
  root.dataset.fitInit = '1';

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var WIDGET = '.cbb-frequently-bought-container';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
  var CLOSE = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  var state = {
    active: false,   // true while the shopper is on the fit option
    full: null,      // { now, was, count } of the complete bundle, as shown by the app
    info: {},        // product data by handle (title, image, option name), fetched once
    atcText: null    // label of the buy button before the fit took it over
  };
  var widget = null, widgetObserver = null, sheet = null, timer = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* "$1,174.60" → 1174.6 ; and back, reusing the store's own money format from a sample. */
  function num(s) {
    var m = String(s || '').match(/[\d.,]*\d/);
    if (!m) return 0;
    var v = m[0];
    if (/[.,]\d{2}$/.test(v)) v = v.slice(0, -3).replace(/[.,]/g, '') + '.' + v.slice(-2);
    else v = v.replace(/[.,]/g, '');
    return parseFloat(v) || 0;
  }
  function money(n, sample) {
    var out = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return /[\d.,]*\d/.test(sample || '') ? sample.replace(/[\d.,]*\d/, out) : '$' + out;
  }
  function text(scope, selector) {
    var el = scope && (scope.querySelector(selector + ' .money') || scope.querySelector(selector));
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* The app can send the shopper to checkout, to the cart page, or leave them on the page after adding.
     On this template the bundle is added to the cart and the shopper stays (the cart drawer opens), unless
     the snippet is rendered with after_add: 'app' to keep whatever is set in the app. Only this page is
     affected; the app's own setting is not changed. */
  function stayOnPage() {
    if (cfg.stay === false) return;
    try {
      var api = window.codeblackbelt && window.codeblackbelt['frequently-bought-togetherApi'];
      var prefs = api && api.readPreferences && api.readPreferences();
      if (!prefs || prefs.dontRedirectPolicy === true) return;
      prefs.redirectToCheckoutPolicy = false;
      prefs.redirectToCartPagePolicy = false;
      prefs.themeDefaultPolicy = false;
      prefs.dontRedirectPolicy = true;
    } catch (e) {}
  }

  /* ---------- reading the app's widget ---------- */
  function read() {
    if (!widget) return { items: [] };
    var items = [].map.call(widget.querySelectorAll('.cbb-frequently-bought-selector-list > li'), function (li, i) {
      var cb = li.querySelector('.cbb-frequently-bought-selector-input');
      var handle = li.getAttribute('p-handle');
      if (!handle) {            // the app fills p-handle late: fall back to the product link inside the row
        var link = li.querySelector('a[href*="/products/"]');
        var m = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }
      return {
        li: li, cb: cb, handle: handle,
        select: li.querySelector('select.cbb-recommendations-variant-select'),
        isThis: !!li.querySelector('.cbb-frequently-bought-this-item-variant-select') || (i === 0 && !handle),
        on: !!(cb && cb.checked),
        name: text(li, '.cbb-frequently-bought-selector-label-name'),
        price: text(li, '.cbb-frequently-bought-selector-label-sale-price') || text(li, '.cbb-frequently-bought-selector-label-regular-price'),
        compare: text(li, '.cbb-frequently-bought-selector-label-compare-at-price')
      };
    }).filter(function (it) { return it.cb; });
    var box = widget.querySelector('.cbb-frequently-bought-total-price-box');
    return {
      items: items,
      now: text(box, '.cbb-frequently-bought-total-price-sale-price') || text(box, '.cbb-frequently-bought-total-price-regular-price'),
      was: text(box, '.cbb-frequently-bought-total-price-was-price'),
      note: text(widget, '.cbb-frequently-bought-discount-message'),
      button: widget.querySelector('.cbb-frequently-bought-add-button')
    };
  }

  /* Full title, photo and option name of the other products come from Shopify, not from the app
     (the app truncates names and only has 100px thumbnails). */
  function loadInfo(handle) {
    if (!handle || state.info[handle]) return;
    state.info[handle] = { loading: true };
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        state.info[handle] = {
          title: p.title,
          image: p.featured_image,
          optionName: p.variants.length === 1 && p.variants[0].title === 'Default Title' ? null : (p.options[0] && (p.options[0].name || p.options[0])),
          optionCount: p.options.length
        };
        schedule();
      })
      .catch(function () {});
  }
  function infoOf(item) {
    if (item.isThis) return cfg.product;
    var i = state.info[item.handle] || {};
    return { title: i.title || item.name, image: i.image ? sized(i.image, 240) : '', optionName: i.optionName, optionCount: i.optionCount || 1 };
  }

  /* ---------- the product's own variant picker (dropdown or buttons) ---------- */
  function mainInputs() {
    return [].slice.call(document.querySelectorAll('.variant-input-wrap')).filter(function (w) { return !w.closest(WIDGET); });
  }
  function mainValue(wrap) {
    var sel = wrap.querySelector('select[data-variant-input], select');
    if (sel) return sel.value;
    var r = wrap.querySelector('input[type="radio"]:checked');
    return r ? r.value : '';
  }
  function mainChoices(wrap) {
    var sel = wrap.querySelector('select[data-variant-input], select');
    if (sel) return [].map.call(sel.options, function (o) { return { value: o.value, label: o.textContent.trim(), disabled: o.disabled, on: o.selected }; });
    return [].map.call(wrap.querySelectorAll('input[type="radio"]'), function (r) {
      return { value: r.value, label: r.value, disabled: r.disabled || r.classList.contains('disabled'), on: r.checked };
    });
  }
  function setMain(wrap, value) {
    var sel = wrap.querySelector('select[data-variant-input], select');
    if (sel) {
      if (sel.value === value) return;
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var r = [].filter.call(wrap.querySelectorAll('input[type="radio"]'), function (x) { return x.value === value; })[0];
    if (r && !r.checked) r.click();
  }

  function caption(item) {
    var info = infoOf(item);
    if (!item.on) return esc(cfg.add);
    var value;
    if (item.isThis) {
      if (!info.optionName) return esc(cfg.oneSize);
      value = mainInputs().map(mainValue).filter(Boolean).join(' / ');
    } else {
      if (!item.select || !item.select.options.length) return esc(cfg.oneSize);
      value = item.select.options[item.select.selectedIndex].textContent.trim();
      if (value === 'Default Title') return esc(cfg.oneSize);
    }
    /* short option names ("Size") are shown before the value; long ones would not fit under the photo */
    var showName = info.optionCount === 1 && info.optionName && String(info.optionName).length <= 5;
    return (showName ? esc(info.optionName) + ' ' : '') + '<b>' + esc(value) + '</b>';
  }

  /* ---------- rendering ---------- */
  function render() {
    timer = null;
    if (!widget || !document.contains(widget)) { if (!boot()) return; }
    var d = read();
    if (!d.items.length || !d.button || d.items.length < 2) { root.hidden = true; release(); return; }

    var picked = d.items.filter(function (i) { return i.on; });
    var extras = picked.filter(function (i) { return !i.isThis; });
    var all = picked.length === d.items.length;
    if (all && d.now) state.full = { now: d.now, was: d.was, count: d.items.length };
    if (!state.full) {            // the app starts with everything checked; if it did not, read the full offer once
      d.items.forEach(function (i) { if (!i.on) i.cb.click(); });
      return schedule();
    }
    if (state.active && !extras.length) state.active = false;   // nothing extra left: back to the single product
    d.items.forEach(function (i) { loadInfo(i.handle); });

    var priceEl = document.querySelector('[data-product-price]');
    var single = priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var partial = state.active && !all;
    var tierTitle = partial ? cfg.yours + ' · ' + picked.length + ' ' + cfg.items : cfg.full + ' · ' + state.full.count + ' ' + cfg.items;
    var tierNow = partial ? d.now : state.full.now;
    var tierWas = partial ? d.was : state.full.was;
    var tierSave = num(tierWas) - num(tierNow);
    var fullSave = num(state.full.was) - num(state.full.now);

    var html = '<div class="fit-opt__top"><span class="fit-opt__lbl" id="fit-opt-lbl">' + esc(cfg.label) + ': <span>' + esc(state.active ? tierTitle : cfg.single) + '</span></span>' +
      (d.note ? '<span class="fit-opt__note">' + esc(d.note) + '</span>' : '') + '</div>' +
      '<div class="fit-opt__tiers" role="radiogroup" aria-labelledby="fit-opt-lbl">' +
        '<button type="button" class="fit-tier" role="radio" aria-checked="' + !state.active + '" data-fit-tier="single">' + esc(cfg.single) + (single ? '<small>' + esc(single) + '</small>' : '') + '</button>' +
        '<button type="button" class="fit-tier" role="radio" aria-checked="' + state.active + '" data-fit-tier="full">' +
          esc(tierTitle) + '<span class="fit-tier__line"><small>' + esc(tierNow) + '</small>' +
          (tierSave > 0 ? '<span class="fit-tier__tag">' + esc(cfg.save) + ' ' + esc(money(tierSave, tierNow)) + '</span>' : '') + '</span></button>' +
      '</div>';

    if (state.active) {
      var needsSizes = picked.some(function (i) {
        return i.isThis ? !!cfg.product.optionName && cfg.product.optionCount === 1 : !!(i.select && i.select.options.length > 1);
      });
      html += '<div class="fit-opt__in"><div class="fit-strip">' + d.items.map(function (it, idx) {
        var info = infoOf(it);
        return '<span class="fit-item' + (it.on ? '' : ' is-off') + (it.isThis ? ' fit-item--this' : '') + '" data-fit-item="' + idx + '">' +
          '<span class="fit-item__ph">' + (info.image ? '<img src="' + esc(info.image) + '" alt="' + esc(info.title) + '" loading="lazy">' : '') +
          (it.isThis ? '' : '<button type="button" class="fit-item__x" aria-pressed="' + it.on + '" aria-label="' + esc((it.on ? cfg.remove : cfg.add) + ' ' + info.title) + '">' + (it.on ? CHECK : PLUS) + '</button>') +
          '</span><small>' + caption(it) + '</small></span>';
      }).join('<span class="fit-strip__plus" aria-hidden="true">+</span>') + '</div>' +
      (all || fullSave <= 0 ? '' : '<p class="fit-opt__msg" role="status">' + esc(cfg.addMore.replace('[count]', d.items.length - picked.length)) + ' <b>' + esc(cfg.save) + ' ' + esc(money(fullSave, state.full.now)) + '</b></p>') +
      '<div class="fit-opt__row"><div class="fit-opt__price"><b>' + esc(d.now) + '</b>' + (d.was && num(d.was) > num(d.now) ? '<s>' + esc(d.was) + '</s><span class="fit-opt__save">' + esc(cfg.youSave) + ' ' + esc(money(num(d.was) - num(d.now), d.now)) + '</span>' : '') + '</div>' +
      (needsSizes ? '<button type="button" class="fit-opt__edit" data-fit-edit>' + esc(cfg.editSizes) + '</button>' : '') + '</div></div>';
    }

    if (root.__html !== html) {
      var focus = document.activeElement && root.contains(document.activeElement) ? focusKey(document.activeElement) : null;
      root.innerHTML = html;
      root.__html = html;
      if (focus) { var again = root.querySelector(focus); if (again) again.focus(); }
    }
    root.hidden = false;
    document.documentElement.classList.add('fit-ready');
    syncButton(d, picked);
    if (sheet && sheet.open) fillSheet();
  }
  function focusKey(el) {
    if (el.dataset.fitTier) return '[data-fit-tier="' + el.dataset.fitTier + '"]';
    if (el.hasAttribute('data-fit-edit')) return '[data-fit-edit]';
    var item = el.closest('[data-fit-item]');
    return item ? '[data-fit-item="' + item.dataset.fitItem + '"] .fit-item__x' : null;
  }
  function schedule() { if (!timer) timer = setTimeout(render, 60); }

  /* ---------- the product's buy button ---------- */
  function buyButton() {
    var btns = document.querySelectorAll('[data-add-to-cart]');
    for (var i = 0; i < btns.length; i++) if (!btns[i].closest(WIDGET)) return btns[i];
    return null;
  }
  function syncButton(d, picked) {
    var btn = buyButton(); if (!btn) return;
    var label = btn.querySelector('[data-add-to-cart-text]') || btn;
    var holder = btn.closest('.product-block') || btn.closest('form') || btn.parentNode;
    if (state.active) {
      var want = cfg.buy.replace('[count]', picked.length) + ' · ' + d.now;
      var current = label.textContent.replace(/\s+/g, ' ').trim();
      if (current !== want) {
        if (!holder.classList.contains('fit-is-active') || current !== state.lastSet) state.atcText = current;
        label.textContent = want;
        state.lastSet = want;
      }
      holder.classList.add('fit-is-active');
    } else {
      release();
    }
  }
  function release() {
    var btn = buyButton(); if (!btn) return;
    var holder = btn.closest('.product-block') || btn.closest('form') || btn.parentNode;
    if (!holder.classList.contains('fit-is-active')) return;
    holder.classList.remove('fit-is-active');
    var label = btn.querySelector('[data-add-to-cart-text]') || btn;
    if (label.textContent.replace(/\s+/g, ' ').trim() === state.lastSet && state.atcText) label.textContent = state.atcText;
  }
  /* While the fit is selected, the buy button hands over to the app's own button. */
  document.addEventListener('click', function (e) {
    if (!state.active || !e.target.closest) return;
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn || btn.closest(WIDGET)) return;
    var d = read();
    if (!d.button) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    stayOnPage();
    d.button.click();
  }, true);

  /* ---------- interactions ---------- */
  root.addEventListener('click', function (e) {
    var d = read();
    var tier = e.target.closest('[data-fit-tier]');
    if (tier) {
      state.active = tier.dataset.fitTier === 'full';
      if (state.active) d.items.forEach(function (i) { if (!i.on) i.cb.click(); });   // the fit starts complete
      return render();
    }
    if (e.target.closest('[data-fit-edit]')) return openSheet();
    var el = e.target.closest('[data-fit-item]');
    if (el && state.active) {
      var it = d.items[+el.dataset.fitItem];
      if (!it || it.isThis) return;
      it.cb.click();                                  // the app recalculates; the observer re-renders
      render();
    }
  });

  /* ---------- sizes sheet ---------- */
  function buildSheet() {
    sheet = document.createElement('dialog');
    sheet.className = 'fit-sheet';
    sheet.setAttribute('aria-labelledby', 'fit-sheet-title');
    sheet.innerHTML = '<div class="fit-sheet__top"><h2 id="fit-sheet-title">' + esc(cfg.sizesTitle) + '</h2>' +
      '<button type="button" class="fit-sheet__close" data-fit-close aria-label="' + esc(cfg.done) + '">' + CLOSE + '</button></div>' +
      '<ul class="fit-sheet__list"></ul><button type="button" class="fit-sheet__done" data-fit-close>' + esc(cfg.done) + '</button>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target === sheet || e.target.closest('[data-fit-close]')) return sheet.close ? sheet.close() : sheet.removeAttribute('open');
      var chip = e.target.closest('.fit-chip');
      if (!chip || chip.getAttribute('aria-disabled') === 'true') return;
      var d = read();
      var it = d.items[+chip.dataset.item];
      if (!it) return;
      if (it.isThis) {
        var wrap = mainInputs()[0];
        if (wrap) setMain(wrap, chip.dataset.value);
      } else if (it.select) {
        it.select.selectedIndex = +chip.dataset.index;
        it.select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      fillSheet(chip.dataset.item + ':' + chip.dataset.index);
      schedule();
    });
  }
  function fillSheet(focusChip) {
    var d = read();
    sheet.querySelector('.fit-sheet__list').innerHTML = d.items.map(function (it, idx) {
      if (!it.on) return '';
      var info = infoOf(it), chips = '';
      if (it.isThis) {
        var wrap = info.optionName && info.optionCount === 1 ? mainInputs()[0] : null;
        if (wrap) chips = mainChoices(wrap).map(function (c, i) {
          return '<button type="button" class="fit-chip" role="radio" aria-checked="' + c.on + '"' + (c.disabled ? ' aria-disabled="true"' : '') + ' data-item="' + idx + '" data-index="' + i + '" data-value="' + esc(c.value) + '">' + esc(c.label) + '</button>';
        }).join('');
      } else if (it.select && it.select.options.length > 1) {
        chips = [].map.call(it.select.options, function (o, i) {
          return '<button type="button" class="fit-chip" role="radio" aria-checked="' + (i === it.select.selectedIndex) + '" data-item="' + idx + '" data-index="' + i + '">' + esc(o.textContent.trim()) + '</button>';
        }).join('');
      }
      return '<li>' + (info.image ? '<img src="' + esc(info.image) + '" alt="">' : '<span></span>') + '<div><span class="fit-sheet__name">' + esc(info.title) + '</span>' +
        (chips ? '<span class="fit-chips" role="radiogroup" aria-label="' + esc(info.title) + '">' + chips + '</span>' : '<span class="fit-sheet__one">' + caption(it) + '</span>') + '</div></li>';
    }).join('');
    if (focusChip) {
      var p = focusChip.split(':'), again = sheet.querySelector('.fit-chip[data-item="' + p[0] + '"][data-index="' + p[1] + '"]');
      if (again) again.focus();
    }
  }
  function openSheet() {
    if (!sheet) buildSheet();
    fillSheet();
    if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
  }

  /* ---------- start: the app renders its widget late, and may render it again ---------- */
  function boot() {
    var w = document.querySelector(WIDGET);
    if (!w || !w.querySelector('.cbb-frequently-bought-selector-input')) return false;
    if (w !== widget) {
      widget = w;
      if (widgetObserver) widgetObserver.disconnect();
      widgetObserver = new MutationObserver(schedule);
      widgetObserver.observe(widget, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['checked', 'style', 'class', 'p-handle', 'href'] });
      widget.addEventListener('change', schedule);
    }
    return true;
  }
  new MutationObserver(function () {
    if (!widget || !document.contains(widget)) { if (boot()) schedule(); }
  }).observe(document.body, { childList: true, subtree: true });

  /* the theme rewrites the button label and the price when the variant changes */
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.variant-input-wrap')) setTimeout(schedule, 150);
  });

  if (boot()) render();
})();
